import { useEffect, useState } from "react";
import { CallWithAuth } from "../../action/apiActions";
import {
  DISABLE_TWO_STEP_VERIFICATION,
  INITIATE_TWO_STEP_VERIFICATION,
  CONFIRM_TWO_STEP_VERIFICATION,
} from "../../action/apiPath";
import { ToastContainer } from "react-toastify";
import { showToast } from "../../util/toastHelper";

export const TwoStepAuthenticationComponent = () => {
  const [isEnabled, setIsEnabled] = useState(null); // null = unknown, true = enabled, false = disabled
  const [qrCode, setQrCode] = useState(null);
  const [isLoading, setisLoading] = useState(false);
  const [value, setValue] = useState("");

  // ✅ Check from localStorage if already enabled
  useEffect(() => {
    const tfaStatus = localStorage.getItem("is_tfa");
    if (!tfaStatus || tfaStatus === "false") {
      setIsEnabled(false);
    } else {
      setIsEnabled(true);
    }
  }, []);

  // ✅ Start enable flow (get QR code)
  const handleStartEnable = async () => {
    setisLoading(true);
    const response = await CallWithAuth("GET", INITIATE_TWO_STEP_VERIFICATION);
    if (response?.res?.data?.statusCode === 200) {
      setQrCode(response?.res?.data?.data?.qrCode);
      setIsEnabled("enabling"); // temporary state while verifying
      // localStorage.setItem("qr_id", response?.res?.data?.data?.id);
    } else {
      showToast("error", response?.res?.data?.message || "Something went wrong");
    }
    setisLoading(false);
  };

  // ✅ Handle OTP input
  const handleChange = (event) => {
    const newValue = event.target.value;
    if (newValue.length <= 6 && /^[0-9]*$/.test(newValue)) {
      setValue(newValue);
    }
  };

  // ✅ Confirm Enable
  const handleEnableVerify = async () => {
    if (value.length === 6) {
      setisLoading(true);
      const body = { otp: value };
      const isTokenAvailable = localStorage.getItem("accessToken");

      if (isTokenAvailable) {
        const response = await CallWithAuth(
          "POST",
          CONFIRM_TWO_STEP_VERIFICATION,
          body
        );

        if (response?.res?.data?.statusCode === 200) {
          showToast("success", response?.res?.data?.message);
          localStorage.setItem("is_tfa", true);
          setValue("");
          setIsEnabled(true);
        } else {
          showToast("error", response?.res?.data?.message || "Invalid OTP");
        }
      }
      setisLoading(false);
    } else {
      showToast("error", "Please enter a valid 6-digit OTP");
    }
  };

  // ✅ Disable
  const handleDisable = async () => {
    if (value.length === 6) {
      setisLoading(true);
      const isTokenAvailable = localStorage.getItem("accessToken");

      if (isTokenAvailable) {
        const body = { code: value };

        const response = await CallWithAuth(
          "POST",
          DISABLE_TWO_STEP_VERIFICATION,
          body
        );

        if (response?.res?.data?.statusCode === 200) {
          localStorage.setItem("is_tfa", false);
          setIsEnabled(false);
          setValue("");
          showToast("success", response?.res?.data?.message);
        } else {
          showToast(
            "error",
            response?.res?.data?.message || "Something went wrong"
          );
        }
      }
      setisLoading(false);
    } else {
      showToast("error", "Please enter a valid 6-digit OTP");
    }
  };

  return (
    <>
      {isLoading && (
        <div className="full-page-loader">
          <div className="loader"></div>
        </div>
      )}


      <section className="create_account_block">
        <div className="site_container">
          <div className="heading-with-button-block">
            <div className="heading_block">
              <h1>Manage Two-Factor Authentication</h1>
            </div>
          </div>
          <div className="create_account_form">
            {/* If disabled initially */}
            {isEnabled === false && (
              <div className="otp-page">
                <h3>Two-Factor Authentication is currently disabled.</h3>
                <button
                  onClick={handleStartEnable}
                  type="button"
                  className="btn btn-primary"
                >
                  Enable 2FA
                </button>
              </div>
            )}

            {/* Enabling flow (show QR + OTP input) */}
            {isEnabled === "enabling" && (
              <div className="otp-page">
                <h3>
                  Scan this QR Code with your authenticator app, then enter the OTP
                  to enable 2FA.
                </h3>
                <div className="field_block">
                  <img
                    src={qrCode}
                    alt="QR Code"
                    style={{ width: "200px", height: "200px" }}
                  />
                </div>

                <div className="field_block">
                  <div className="otp-box">
                  <input
                    type="number"
                    max={6}
                    className="form-control"
                    value={value}
                    onChange={handleChange}
                    placeholder="Enter 6-digit OTP"
                  />
                </div>
                </div>

                <div
                  className="btn_block disable-two-step-button"
                  style={{ marginTop: "10px" }}
                >
                  <button onClick={handleEnableVerify} type="button">
                    Verify & Enable
                  </button>
                </div>


              </div>
            )}

            {/* Already enabled */}
            {isEnabled === true && (
              <div className="otp-page">
                <h3>Two-Factor Authentication is enabled.</h3>
                <div className="field_block">
                  <label>Enter OTP to disable 2FA.</label>
                  <div className="otp-box">
                    <input
                      type="number"
                      max={6}
                      className="form-control"
                      value={value}
                      onChange={handleChange}
                      placeholder="Enter 6-digit OTP"
                    />
                  </div>
                </div>


                <div
                  className="btn_block disable-two-step-button"
                  style={{ marginTop: "10px" }}
                >
                  <button onClick={handleDisable} type="button">
                    Disable Authentication
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      <ToastContainer />
    </>
  );
};
